import { APIClient } from '../../../helpers/api_helper';

import { registerUserSuccessful, registerUserFailed, resetRegisterFlagChange, apiErrorChange } from './reducer';

export const registerUser = user => async dispatch => {
    try {
        const { data } = await APIClient.post('/auth/register', user);
        if (data.message === 'success') {
            dispatch(registerUserSuccessful(data));
        } else {
            dispatch(registerUserFailed(data));
        }
    } catch (error) {
        dispatch(registerUserFailed(error));
    }
};

export const resetRegisterFlag = () => {
    try {
        const response = resetRegisterFlagChange();
        return response;
    } catch (error) {
        return error;
    }
};

export const apiError = () => {
    try {
        const response = apiErrorChange('');
        return response;
    } catch (error) {
        return error;
    }
};
